import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import withConfig from '@/config/withConfig';
import SearchTracking, { SEARCH_TRACKING_ACTIONS } from 'utils/search-tracking';
import { resetFilters } from 'store/filters/filters-actions';
import { panMap, setZoom } from 'store/search/search-actions';
import { push, replace } from 'store/router/router-actions';
import { routeToSpotDetails } from 'router/router-utils';
import SpotMap from '../spot-map';
import { setSpotDetailReferrer } from 'store/spot/spot-actions';
import GoogleMapLoadingError from 'common/search-results-map/google-map/GoogleMapLoadingError';
/**
 * SearchMap is the outermost "layer" of the map components (SearchMap, SpotMap, SHGoogleMap).
 *
 * This component is responsible for:
 * - Passing down high-level data (spots, destination).
 * - Determining what to do actually do with a zoom, pan, or marker click.
 * (e.g. call search, pass data to analytics)
 */
const SearchMap = (props) => {
    const { isMobile, spots, isFiltered, destination, findParkingNearMe, resetFiltersClick, isAdmin, recentlyViewedSpots, googleMapError, onShowDetailsClick, setSpotDetailReferrerTo, pushTo, sendMapZoomAnalytics, loadSpots = () => { }, sendMapPanAnalytics, } = props;
    const { searchUUID } = SearchTracking.getValues();
    const onSpotDetail = (spotId) => {
        const { history: { location }, } = props;
        onShowDetailsClick(spotId);
        setSpotDetailReferrerTo('pin');
        routeToSpotDetails({
            method: pushTo,
            location,
            spotId,
            historyState: { referrer: 'pin' },
        });
    };
    const onZoom = ({ zoom, prevZoom, mapCenter, mapBounds }) => {
        sendMapZoomAnalytics({
            level: zoom,
            previousLevel: prevZoom,
            mapCenter,
            mapBounds,
        });
        if (zoom < prevZoom) {
            loadSpots({
                searchTrackingAction: SEARCH_TRACKING_ACTIONS.ZOOM,
                mapCenter,
                mapBounds,
            });
        }
    };
    const onPan = ({ mapCenter, mapBounds }) => {
        sendMapPanAnalytics({
            mapCenter,
            mapBounds,
        });
        loadSpots({
            searchTrackingAction: SEARCH_TRACKING_ACTIONS.PAN,
            mapCenter,
            mapBounds,
        });
    };
    if (googleMapError) {
        return <GoogleMapLoadingError />;
    }
    return (<div className="SearchMap">
            <SpotMap isAdmin={isAdmin} isNoResultsModalEnabled={isMobile} searchRequestId={searchUUID} isFiltered={isFiltered} onPan={onPan} onZoom={onZoom} onMarkerClick={onSpotDetail} destination={destination} spots={spots} recentlyViewedSpots={recentlyViewedSpots} resetFiltersClick={resetFiltersClick} findParkingNearMe={findParkingNearMe}/>
        </div>);
};
const mapStateToProps = state => {
    const { search: { data: { currentIncrement, requestIncrements, zoom, overrideIdealZoom, destinationTitle, kmlMapLayerEnabled, kmlMapLayerURL, searchType, }, }, searchRequest: { starts, ends, monthly, latitude, longitude, search_string: searchString, ideal_search_distance: idealDistance, }, filters: { numActive }, user: { data: { isAdmin }, }, search: { recentlyViewedSpots }, } = state;
    return {
        isAdmin,
        starts,
        ends,
        isMonthly: monthly,
        isFiltered: numActive > 0,
        searchString,
        latitude,
        longitude,
        destination: {
            title: destinationTitle,
            position: { latitude, longitude },
        },
        zoom,
        idealDistance,
        overrideIdealZoom,
        mapLoadingIncrement: currentIncrement,
        requestIncrements,
        kmlMapLayerEnabled,
        kmlMapLayerURL,
        searchType,
        recentlyViewedSpots,
    };
};
const mapDispatchToProps = {
    resetFiltersClick: resetFilters,
    sendMapZoomAnalytics: setZoom,
    sendMapPanAnalytics: panMap,
    pushTo: push,
    routeReplace: replace,
    setSpotDetailReferrerTo: setSpotDetailReferrer,
};
const enhance = compose(withConfig(['isMobile', 'staticBaseUrl']), withRouter, connect(mapStateToProps, mapDispatchToProps));
export { SearchMap as UnwrappedSearchMap };
export default enhance(SearchMap);
